import * as React from 'react';

import {
  AttachmentFragment,
  ClaimItemSelectionAttachmentName,
  Status,
  useAttachItemSelectionAttachmentMutation,
  useDetachItemSelectionAttachmentMutation,
} from '@portal/schema';

interface IAttacherProps {
  name: ClaimItemSelectionAttachmentName;
  uuid: string;
  selectionID: string;
  onAttach(attachment: AttachmentFragment): void;
  onDetach(attachment: AttachmentFragment): void;
  children(props: {
    loading: boolean;
    error?: string;
    attach(signedID: string): void;
    detach(attachmentID: string): void;
  }): React.ReactElement;
}

export const Attacher = ({ name, uuid, selectionID, onAttach, onDetach, children }: IAttacherProps) => {
  const [attach, { loading: attaching, data: attached }] = useAttachItemSelectionAttachmentMutation();
  const [detach, { loading: detaching, data: detached }] = useDetachItemSelectionAttachmentMutation();

  return children({
    loading: attaching || detaching,
    error: attached?.result?.error ?? detached?.result?.error ?? undefined,
    attach: async (signedID: string) => {
      const { data } = await attach({ variables: { uuid, selectionID, signedID, name } });
      if (data?.result && data.result.attachment && data.result.status === Status.Ok) onAttach(data.result.attachment);
    },
    detach: async (attachmentID: string) => {
      const { data } = await detach({ variables: { uuid, selectionID, attachmentID, name } });
      if (data?.result && data.result.attachment && data.result.status === Status.Ok) onDetach(data.result.attachment);
    },
  });
};
